/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ConversationPromptDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class PromptController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags prompt-controller
   * @name GetPrompts
   * @request GET:/api/v1/copilot/prompts
   */
  getPrompts = (params: RequestParams = {}) =>
    this.http.request<ConversationPromptDto[], any>({
      path: `/v1/copilot/prompts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPromptsPath = '/v1/copilot/prompts'
  static getPromptsMethod = 'GET'
}
